import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Scales/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class ScalesCommands extends VueCqrs {

	invokeCreateWorkspaceScaleCommandV1(workspaceId: number, discreteScaleId: number, name: string, description: string, levelsSerialized: string)
	{
		const cmd = new c.CreateWorkspaceScaleCommandV1(workspaceId, discreteScaleId, name, description, levelsSerialized);
		this.$command(cmd, discreteScaleId.toString());
	}

	invokeDeleteWorkspaceScaleCommandV1(workspaceId: number, discreteScaleId: number)
	{
		const cmd = new c.DeleteWorkspaceScaleCommandV1(workspaceId, discreteScaleId);
		this.$command(cmd, discreteScaleId.toString()); // 
	}

	invokeUpdateWorkspaceScaleCommandV1(workspaceId: number, discreteScaleId: number, name: string, description: string, levelsSerialized: string)
	{
		const cmd = new c.UpdateWorkspaceScaleCommandV1(workspaceId, discreteScaleId, name, description, levelsSerialized);
		this.$command(cmd, discreteScaleId.toString());
	}
}
